// AI Content Display Component
import React from 'react';
import { Container } from 'react-bootstrap';
import openCapacitorSite from '../../utils/browserUtils';
import './AIContentDisplay.css';

const AIContentDisplay = ({ searchResponse, onCitationClick }) => {
  // Function to convert markdown to HTML (from old code)
  const parseMarkdownToHTML = (text) => {
    if (!text) return '';
    
    // Convert **bold** to <strong>bold</strong>
    let html = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    
    // Convert *italic* to <em>italic</em>
    html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
    
    // Convert headers ### to <h3>
    html = html.replace(/^###\s+(.+)$/gm, '<h3>$1</h3>');
    html = html.replace(/^##\s+(.+)$/gm, '<h2>$1</h2>');
    html = html.replace(/^#\s+(.+)$/gm, '<h1>$1</h1>');
    
    // Convert markdown tables to HTML tables
    html = html.replace(/\|(.+)\|/g, (match, content) => {
      const cells = content.split('|').map(cell => cell.trim());
      const isHeaderSeparator = cells.every(cell => cell.match(/^-+$/));
      
      if (isHeaderSeparator) {
        return ''; // Remove separator row
      }
      
      const cellTags = cells.some(cell => cell.includes('Details') || cell.includes('Aspect')) ? 'th' : 'td';
      const cellsHtml = cells.map(cell => `<${cellTags}>${cell}</${cellTags}>`).join('');
      return `<tr>${cellsHtml}</tr>`;
    });
    
    // Wrap table rows in table tags
    html = html.replace(/(<tr>.*<\/tr>)/s, '<table class="ai-content-table"><tbody>$1</tbody></table>');
    
    // Convert line breaks to <br> tags
    html = html.replace(/\n/g, '<br>');
    
    // Convert markdown links [text](url) to HTML links
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer" class="ai-content-link">$1</a>');
    
    // Convert citation numbers [1] to clickable links
    html = html.replace(/\[(\d+)\]/g, '<a href="#citation-$1" class="ai-citation-link">[$1]</a>');
    
    // Convert bullet points (- or *) to HTML lists
    html = html.replace(/^[\-\*]\s+(.+)$/gm, '<li>$1</li>');
    html = html.replace(/(<li>.*<\/li>)/s, '<ul class="ai-content-list">$1</ul>');
    
    return html;
  };

  // Function to scroll to citation
  const scrollToCitation = (citationNumber) => {
    const element = document.getElementById(`citation-${citationNumber}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.style.backgroundColor = 'var(--accent-hover)';
      element.style.color = 'white';
    }
    if (onCitationClick) {
      onCitationClick(citationNumber);
    }
  };

  if (!searchResponse?.content) {
    return null;
  }

  return (
    <Container id='aiResponseContainer' className="ai-response-container">
      <div 
        className="ai-content-body"
        dangerouslySetInnerHTML={{ __html: parseMarkdownToHTML(searchResponse.content) }}
        onClick={(e) => {
          // Handle citation link clicks
          if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#citation-')) {
            e.preventDefault();
            const citationNumber = e.target.getAttribute('href').replace('#citation-', '');
            scrollToCitation(citationNumber);
          }
          // Handle external link clicks
          else if (e.target.tagName === 'A' && e.target.href && !e.target.getAttribute('href')?.startsWith('#')) {
            e.preventDefault();
            openCapacitorSite(e.target.href);
          }
        }}
      />
    </Container>
  );
};

export default AIContentDisplay;